import React from 'react';
import ReactDOM from 'react-dom/client';
import './style/bootstrap.scss';
import './index.css';
import App from './App';

if ("scrollRestoration" in window.history) {
  window.history.scrollRestoration = "manual";
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
